import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
    getCombinedToken as getAccessToken,
    clearCombinedToken as clearAccessToken,
} from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
import type { ErrorResponse } from '../types';

const authenticatedIdentityBaseQuery: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError | ErrorResponse
> = async (args, WebApi, extraOptions) => {
    const baseUrl = getConfig().identity_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = getAccessToken()?.access_token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            } else {
                clearAccessToken();
            }
            return headers;
        },
    });
    const result = await rawBaseQuery(args, WebApi, extraOptions);
    if (result.error && result.error.status === 401) {
        clearAccessToken();
    }
    return result;
};

export const AuthenticatedIdentityApiClient = createApi({
    reducerPath: 'authenticatedIdentityAPI',
    baseQuery: authenticatedIdentityBaseQuery,
    endpoints: () => ({}),
});
